/**
 * @generated SignedSource<<703c61dde23d652ba501e48bfae80ac8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventScreenNewDesktop_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventHostInvitationBanner_query" | "EventScreenAttendCard_query" | "EventScreenJoin_query" | "SponsorsSection_query">;
  readonly " $fragmentType": "EventScreenNewDesktop_query";
};
export type EventScreenNewDesktop_query$key = {
  readonly " $data"?: EventScreenNewDesktop_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenNewDesktop_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewDesktop_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SponsorsSection_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenAttendCard_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenJoin_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventHostInvitationBanner_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c9aada299fc02559c7df9e7330455fc4";

export default node;
